export { default as DefaultLogoIcon } from '@/assets/graphics/logoIcons/default/logoIcon.svg';
export { default as GolfLogoIcon } from '@/assets/graphics/logoIcons/golf/logoIcon.svg';
export { default as RejseklubbenLogoIcon } from '@/assets/graphics/logoIcons/rejseklubben/logoIcon.svg';
export { default as SafariLogoIcon } from '@/assets/graphics/logoIcons/safari/logoIcon.svg';
